<template>
    <section>
        <SideBar v-if="!OpenMode" />
        <TopBar v-if="!OpenMode" />
        <div :class="[!OpenMode ? 'content' : '' ]">   
        <div class="main-content-header">
            <h1>Maestro de Proveedores</h1>
        </div>
        <LoadingContent v-if="isLoading" />
        <div class="row">
            <div class="col-lg-12 col-md-6">
                <div class="card mb-30" :style="{height:[contentHeight+'px']}">
                    <div class="row " :class="[!OpenMode ? 'p-4' : '']">
                        <div class="content-header  col-12"> 
                            <div class="row">
                                <div class="col-4 text-start"></div>
                                <div class="col-3 text-start"></div>
                                <div class="col-3 text-start"></div>
                                <div class="col-2"><p class="p-1 pe-4 mb-0 text-end">Página {{ paginaActual }} de {{ totalPaginas }} </p></div>
                                <div class="col-2 offset-10 ps-2 pe-5 text-end pb-0 pt-0">
                                    <ul class="list-unstyled mb-0 d-flex justify-content-between pager-btns float-right">
                                        <li><button @click="setPaginacion('first')" type="button" class="pager pager-first btn btn-sm btn-outline-secondary"><ChevronDoubleLeftIcon /></button></li>
                                        <li><button @click="setPaginacion('prev')"  type="button" class="pager pager-prev  btn btn-sm btn-outline-secondary"><ChevronLeftIcon /></button></li>
                                        <li><button @click="setPaginacion('next')"  type="button" class="pager pager-next  btn btn-sm btn-outline-secondary"><ChevronRightIcon /></button></li>
                                        <li><button @click="setPaginacion('last')"  type="button" class="pager pager-last  btn btn-sm btn-outline-secondary"><ChevronDoubleRightIcon /></button></li> 
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-10 col-12">
                            <div class="table-responsive ps-2">
                                <b-table-simple class="browse" hover small caption-top responsive >
                                    <b-thead head-variant="light" class="table-header">
                                        <b-tr>
                                            <b-th class="text-nowrap">Suc</b-th>
                                            <b-th class="text-nowrap">Prov</b-th>
                                            <b-th class="text-nowrap">Nombre</b-th>
                                            <b-th class="text-nowrap">Abrev</b-th>
                                            <b-th class="text-nowrap">Dirección</b-th>
                                            <b-th class="text-nowrap">Colonia</b-th>
                                            <b-th class="text-nowrap">Ciudad, Edo.</b-th>
                                            <b-th class="text-nowrap">CP</b-th>
                                            <b-th class="text-nowrap">RFC</b-th>
                                            <b-th class="text-nowrap">CURP</b-th>
                                            <b-th class="text-nowrap">Teléfono</b-th>
                                            <b-th class="text-nowrap">Contacto</b-th>
                                            <b-th class="text-nowrap">Correo</b-th>
                                            <b-th class="text-nowrap">Tipo</b-th>
                                        </b-tr>
                                    </b-thead>
                                    <b-tbody>
                                        <b-tr v-for="proveedor in proveedores" :key="proveedor.prove" @click="selectedRegistro=proveedor" 
                                        @dblclick=" (!OpenMode ? modificar() : exportRegistry()) " :class="{'selected-row': (selectedRegistro.prove == proveedor.prove) }">
                                            <b-td class="text-nowrap">{{ proveedor.sucursal| leadingZeros(3)}}</b-td>
                                            <b-td class="text-center text-nowrap" >{{ proveedor.prove | leadingZeros(5)}}</b-td>
                                            <b-td class="text-nowrap">{{ proveedor.nombre }}</b-td>
                                            <b-td class="text-nowrap">{{ proveedor.abrev }}</b-td>
                                            <b-td class="text-nowrap">{{ proveedor.dir1}}</b-td>
                                            <b-td class="text-nowrap">{{ proveedor.dir2}}</b-td>
                                            <b-td class="text-nowrap">{{ proveedor.dir3}}</b-td>
                                            <b-td class="text-nowrap">{{ proveedor.cpostal}}</b-td>
                                            <b-td class="text-nowrap">{{ proveedor.rfc }}</b-td>
                                            <b-td class="text-nowrap">{{ proveedor.curp }}</b-td>
                                            <b-td class="text-nowrap">{{ proveedor.telefono}}</b-td>
                                            <b-td class="text-nowrap">{{ proveedor.contacto }}</b-td>
                                            <b-td class="text-nowrap">{{ proveedor.correo}}</b-td>
                                            <b-td class="text-nowrap">{{ proveedor.tipoprove}}</b-td>
                                        </b-tr>
                                    </b-tbody>
                                </b-table-simple>
                            </div>
                        </div> 
                        <div class="col-2 ps-2 pe-5" >
                            <ul class="d-block list-unstyled action-block">
                                <li v-if="!OpenMode"><router-link to="/proveedores/agregar" type="button" class="btn btn-xs btn-success btn-block">Agregar</router-link></li>
                                <li v-if="!OpenMode"><button @click="modificar()" :disabled="disableBtn" type="button" class="btn btn-xs btn-primary btn-block">Cambiar</button></li>
                                <li v-if="!OpenMode"><button @click="borrar()" :disabled="disableBtn" type="button" class="btn btn-xs btn-danger btn-block">Borrar</button></li>
                                <li v-if="!OpenMode"><button @click="imprimir()" type="button" class="btn btn-xs btn-secondary btn-block">Imprimir</button></li>
                                <li v-if="OpenMode"><button @click="exportRegistry()" type="button" class="btn btn-xs btn-success btn-block">Elegir</button></li>
                            </ul>
                        </div>
                        
                        <div class="content-footer col-12 text-start"></div>
                    </div>
                </div>
            </div>
        </div>
        <PrintComponentVue v-if="print" @close="closePopup">
            <template  v-slot:title >Reporte de Proveedores</template>
        </PrintComponentVue>
        </div>
    </section>
</template>

<script>

import ChevronLeftIcon from 'vue-material-design-icons/ChevronLeft.vue';
import ChevronDoubleRightIcon from 'vue-material-design-icons/ChevronDoubleRight.vue';
import ChevronDoubleLeftIcon from 'vue-material-design-icons/ChevronDoubleLeft.vue';
import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue';
import LoadingContent from '@/components/LoadingSpinner.vue'
import handleGlobals from '@/mixins/handleGlobals'
import handleBrowse from '@/mixins/handleBrowse'
import PrintComponentVue from '@/components/PrintComponent.vue'; 

import SideBar from '@/components/SideBarNav.vue';
import TopBar from '@/components/TopBarNav.vue';

export default {
    name:'WIN_CpProveedores',
    props:['mode','perpage'],
    mixins:[handleGlobals,handleBrowse],
    components:{SideBar,TopBar,ChevronLeftIcon,ChevronDoubleRightIcon,ChevronDoubleLeftIcon,ChevronRightIcon, LoadingContent,PrintComponentVue},
    data(){
        return{
            proveedores: []
        }
    },
    created(){
        if(this.OpenMode == false){
            this.getFiltros()
        } 
    },
    methods:{
        async getFiltros(){
                await fetch(this.$api+'/rdx', {    
                    method: "POST",
                    headers: {
                        'Content-Type' : 'application/json',
                        'Authorization' : this.$store.state.iasctratkn
                    },
                    body: JSON.stringify({accion: "filters"})
                }).then((response)=>{
                    if(response.ok){
                        return response.json()
                    }
                }).then((data)=>{
                    let reg = data['PRO']
                    if(reg){
                        this.paginaActual       = reg['paginaActual'].dato
                        if(this.paginaActual == '') this.paginaActual = 0
                    }else{
                        this.paginaActual       = 1
                    }
                }).catch((err)=>{
                this.falseToken(err)
            });
            },
        consultar(){
            this.isLoading = true
            
            fetch(this.$api+'/rdx', {
                method: "POST",
                headers: { "Content-Type": "application/json",
                            'Authorization' : this.$store.state.iasctratkn },
                body: JSON.stringify({  accion: "browse", 
                                        archivo: "CpProveedores", 
                                        activarPaginas: true,
                                        orden: "prove",
                                        filtro: {paginaActual: {dato: 'NA'}},
                                        pagina: this.paginaActual, 
                                        paginacion: this.paginacion,
                                        registrosxpagina: this.rows })
            }).then((response)=>{
                if(response.ok){
                    return response.json();
                }   
            }).then((data)=>{
                this.proveedores    = data['registros'];
                this.totalRegistros = data['totalRegistros'];
                this.totalPaginas   = data['totalPaginas'];
                this.paginaActual   = data['paginaActual'];
            }).finally(()=>{
                this.isLoading = false;
            }).catch((err)=>{
                this.falseToken(err)
            });
        },
        borrar(){

        },
        imprimir(){
            this.print = true
        },
        modificar(){
            this.$router.push({ name: 'CProveedores', params: {proveedor: this.selectedRegistro.prove}});
        },
    }
}
</script>

